import React from 'react';
import { NavPages } from '../components/NavPages';

const ThankYou = () => {
  return (
    <>
      <NavPages />
      <section>
        <div className='container tc'>
          <div className='s-80'></div>
          <div className='w-100 flex aic jcc'>
            <div className='h-40'>
              <h3 className='title-sub dark w-100'>Дякуємо за ваше звернення!</h3>
              <p className='title-text c-dark'>
                Ми отримали ваше повідомлення і зв'яжемося з вами найближчим часом
              </p>
              <div className='s-30'></div>
              <div className='flex jcc aic'>
                <a href='/' className='button bg-blue mx-2'>
                  Повернутися на головну
                </a>
                <a 
                  href='https://t.me/+lHQh6rdzKAQ3ZjJi' 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className='button bg-theme mx-2'
                >
                  Наш Telegram
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export { ThankYou };